<template>
  <section id="conversation">
    <b-breadcrumb
      :items="breadcrumb"
    />

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="filters"
          title="Filtros"
          class="form-filters"
          :action-close="false"
          :action-refresh="false"
          :action-collapse="true"
          @refresh="refreshStop('cardAction')"
        >
          <b-row>
            <b-col cols="4">
              <b-form-group
                label="Data início"
                label-for="date_from"
              >
                <b-input-group>
                  <cleave
                    id="date_from"
                    v-model="runtimeFilters.date_from"
                    type="text"
                    class="form-control"
                    placeholder="DD/MM/YYYY"
                    autocomplete="off"
                    :raw="false"
                    show-decade-nav
                    :options="maskDate"
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="date_from_dp"
                      show-decade-nav
                      button-only
                      button-variant="outline-primary"
                      right
                      size="sm"
                      :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                      locale="pt-BR"
                      aria-controls="date_from"
                      @context="(ctx) => { runtimeFilters.date_from = (ctx.selectedDate) ? ctx.selectedFormatted : '' }"
                    />
                  </b-input-group-append>

                  <b-input-group-append v-if="runtimeFilters.date_from.length > 0">
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="runtimeFilters.date_from = ''"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group
                label="Data fim"
                label-for="date_to"
              >
                <b-input-group>
                  <cleave
                    id="date_to"
                    v-model="runtimeFilters.date_to"
                    type="text"
                    class="form-control"
                    placeholder="DD/MM/YYYY"
                    autocomplete="off"
                    :raw="false"
                    show-decade-nav
                    :options="maskDate"
                  />
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="date_to_dp"
                      show-decade-nav
                      button-only
                      button-variant="outline-primary"
                      right
                      size="sm"
                      :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                      locale="pt-BR"
                      aria-controls="date_to"
                      @context="(ctx) => { runtimeFilters.date_to = (ctx.selectedDate) ? ctx.selectedFormatted : '' }"
                    />
                  </b-input-group-append>

                  <b-input-group-append v-if="runtimeFilters.date_to.length > 0">
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      @click="runtimeFilters.date_to = ''"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group
                label="User ID"
                label-for="user_id"
              >
                <b-form-input
                  id="user_id"
                  v-model.trim="runtimeFilters.user_id"
                  type="number"
                  min="1"
                  placeholder="Digite o ID do usuário"
                />
              </b-form-group>
            </b-col>

            <b-col cols="4">
              <b-form-group
                label="Opções"
                label-for="is_removed"
              >
                <b-form-select
                  id="is_removed"
                  v-model="runtimeFilters.is_removed"
                  :options="removedOptions"
                />
              </b-form-group>
            </b-col>

            <b-col
              cols="12"
              class="form-buttons text-right d-flex justify-content-end flex-wrap align-content-end"
            >
              <b-form-group
                label=""
                label-for="btn-buscar"
                style="margin-top: 20px"
              >
                <b-button
                  id="btn-buscar"
                  :disabled="isLoading"
                  variant="primary"
                  @click="getUsers"
                >
                  <b-spinner
                    v-if="isLoading"
                    small
                  />
                  Atualizar
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-actions>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card-actions
          ref="results"
          title="Experto - Dashboard"
          class="form-filters"
          :action-close="false"
          :action-refresh="false"
          :action-collapse="true"
          @refresh="refreshStop('cardAction')"
        >
          <b-row class="mb-2">
            <b-col cols="12">
              <div class="experto-summary py-2 px-3 border rounded bg-light d-flex flex-column">
                <span>Total de expertos já criados: <strong>{{ totalExpertoCount }}</strong></span>
                <span>Total de expertos ativos: <strong>{{ activedExpertoCount }}</strong></span>
                <span>Contatados: <strong>{{ sentMessageCount }}</strong></span>
                <span>Interessados: <strong>{{ answeredMessageCount }}</strong></span>
                <span>Respondidos: <strong>{{ contactedMessageCount }}</strong></span>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-table
                :busy="isLoading"
                responsive
                :items="detailed"
                :fields="result_fields"
                show-empty
                sort-icon-left
                no-local-sorting
              >
                <template #empty>
                  <h4 class="text-center mt-2 mb-2">
                    Nenhum resultado encontrado.
                  </h4>
                </template>

                <template #cell(user_id)="row">
                  <a
                    target="_blank"
                    :href="`/cms/user-form/${row.value}`"
                  >{{ row.value }} - {{ row.item.name }}</a>
                  <br />
                </template>

                <template #cell(sent)="row">
                  <span>
                    <a
                      href="#"
                      class="text-primary"
                      @click.prevent="showSentUsers(row.item)"
                    >
                      {{ row.value }}
                    </a>
                  </span>
                </template>

                <template #cell(answered)="row">
                  <span>
                    <a
                      href="#"
                      class="text-primary"
                      @click.prevent="showAnsweredUsers(row.item)"
                    >
                      {{ row.value }}
                    </a>
                  </span>
                </template>

                <template #cell(contacted)="row">
                  <span>
                    <a
                      href="#"
                      class="text-primary"
                      @click.prevent="showContactedUsers(row.item)"
                    >
                      {{ row.value }}
                    </a>
                  </span>
                </template>

                <template #cell(created_at)="row">
                  <p>
                    Criado em: <span>{{ formatDateDbToView(row.value) }}</span>
                    <span v-if="params.is_removed">
                      <br />Removido em: <span>{{ formatDateDbToView(row.item.deleted_at) }}</span>
                      <br />Razão: <span>{{ row.item.reason }}</span>
                      <br />Descrição: <span>{{ row.item.sub_reason }}</span>
                    </span>
                  </p>
                </template>

                <template #table-busy>
                  <div class="text-center table-spinner">
                    <b-spinner label="Loading..." />
                    <strong>Carregando...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card-actions>

      </b-col>
    </b-row>

    <b-modal
      id="modal-users-detail"
      ref="modalUsersDetail"
      :title="modalTitle"
      size="xl"
      hide-footer
    >
      <div
        v-if="modalUsersLoading"
        class="text-center py-4"
      >
        <b-spinner
          label="Loading..."
          small
        />
        <span class="ml-2">Carregando usuários...</span>
      </div>

      <div v-else>
        <b-table
          :items="modalUsers"
          :fields="filteredModalFields"
          small
          responsive
          show-empty
        >
          <template #empty>
            <h5 class="text-center my-3">
              Nenhum usuário encontrado
            </h5>
          </template>

          <template #cell(message_id)="row">
            {{ row.value ? 'Sim' : 'Não' }}
          </template>

          <template #cell(contacted)="row">
            {{ row.value ? 'Sim' : 'Não' }}
          </template>

          <template #cell(target_id)="row">
            <a
              target="_blank"
              :href="`/cms/user-form/${row.value}`"
            >{{ row.value }} - {{ row.item.name }}</a>
          </template>

          <template #cell(created_at)="row">
            <span>{{ formatDateTimeDbToView(row.value) }}</span>
          </template>
        </b-table>
      </div>

      <template #modal-footer>
        <b-button
          variant="secondary"
          @click="closeModal"
        >
          Fechar
        </b-button>
      </template>
    </b-modal>
  </section>
</template>

<script>
import Cleave from 'vue-cleave-component'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { formatDateDbToView, formatDateTimeDbToView, formatDateViewToDb } from '@/utils/helpers'
import { maskDate } from '@/utils/masks'
import {
  BRow,
  BCol,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormDatepicker,
  BFormInput,
  BFormSelect,
  BSpinner,
  BButton,
  BBreadcrumb,
  BTable,
  BModal,
} from 'bootstrap-vue'
import ExpertoService from '@/services/expertoService'

export default {
  components: {
    BFormSelect,
    BFormInput,
    Cleave,
    BFormDatepicker,
    BInputGroup,
    BInputGroupAppend,
    BTable,
    BModal,
    BCardActions,
    BRow,
    BCol,
    BFormGroup,
    BSpinner,
    BButton,
    BBreadcrumb,
  },
  data() {
    return {
      isLoading: false,
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'cms-dashboard' },
        },
        {
          text: 'Ferramentas',
          active: true,
        },
        {
          text: 'Experto',
          active: true,
        },
      ],
      results: [],
      detailed: [],
      result_fields: [],
      formatDateTimeDbToView,
      formatDateDbToView,
      maskDate,
      runtimeFilters: {
        user_id: '',
        date_from: '',
        date_to: '',
        is_removed: 0,
      },
      removedOptions: [
        { value: 0, text: 'Exibir os ativos' },
        { value: 1, text: 'Exibir os removidos' },
      ],
      params: {},
      date_from_dp: '',
      date_to_dp: '',
      modalUsers: [],
      modalUsersLoading: false,
      modalType: 'sent',
      allModalFields: [
        { key: 'target_id', label: 'ID do Usuário', sortable: false },
        { key: 'email', label: 'E-mail', sortable: false },
        { key: 'message_id', label: 'Interessado', sortable: false },
        { key: 'contacted', label: 'Respondido', sortable: false },
        { key: 'created_at', label: 'Contatado em', sortable: false },
      ],
    }
  },

  computed: {
    modalTitle() {
      if (this.modalType === 'sent') {
        return `Usuários contatados (${this.modalUsers.length})`
      }
      if (this.modalType === 'contacted') {
        return `Usuários respondidos (${this.modalUsers.length})`
      }
      return `Usuários retornados (${this.modalUsers.length})`
    },
    filteredModalFields() {
      if (this.modalType === 'sent') {
        return this.allModalFields
      }
      if (this.modalType === 'contacted') {
        return this.allModalFields.filter(f => f.key !== 'message_id' && f.key !== 'contacted')
      }
      return this.allModalFields.filter(f => f.key !== 'message_id')
    },
    totalExpertoCount() {
      if (!this.results) {
        return 0
      }

      return this.results.total || 0
    },
    activedExpertoCount() {
      if (!this.results) {
        return 0
      }

      return this.results.actives || 0
    },
    sentMessageCount() {
      if (!this.results) {
        return 0
      }

      return this.results.messages_sent || 0
    },
    answeredMessageCount() {
      if (!this.results) {
        return 0
      }

      return this.results.messages_answered || 0
    },
    contactedMessageCount() {
      if (!this.results) {
        return 0
      }

      return this.results.messages_contacted || 0
    },
  },

  watch: {
  },

  created() {
    this.getUsers()

    this.result_fields = [
      { key: 'user_id', label: 'Usuário', sortable: false },
      { key: 'sent', label: 'Contatados', sortable: false },
      { key: 'answered', label: 'Interessados', sortable: false },
      { key: 'contacted', label: 'Respondidos', sortable: false },
      { key: 'created_at', label: 'Criado em', sortable: false },
    ]
  },

  methods: {
    getUsers() {
      if (this.isLoading) {
        return false
      }

      this.isLoading = true

      const params = {
        is_removed: Number(this.runtimeFilters.is_removed),
      }

      if (this.runtimeFilters.user_id) {
        params.user_id = this.runtimeFilters.user_id
      }

      if (this.runtimeFilters.date_from) {
        params.date_from = formatDateViewToDb(this.runtimeFilters.date_from)
      }

      if (this.runtimeFilters.date_to) {
        params.date_to = formatDateViewToDb(this.runtimeFilters.date_to)
      }

      this.params = params

      ExpertoService.getDashboard(this.params).then(response => {
        if (response.data !== null) {
          this.results = response.data.data.experto
          this.detailed = response.data.data.experto.detailed
        }

        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })

      return true
    },

    showSentUsers(item) {
      this.modalType = 'sent'
      this.modalUsers = []
      this.modalUsersLoading = true

      ExpertoService.getSentMessages(item.user_id).then(response => {
        if (response.data !== null) {
          this.modalUsers = response.data.data.sent_messages || []
        }

        this.modalUsersLoading = false
      }).catch(() => {
        this.modalUsersLoading = false
      })

      this.$refs.modalUsersDetail.show()
    },

    showAnsweredUsers(item) {
      this.modalType = 'answered'
      this.modalUsers = []
      this.modalUsersLoading = true

      ExpertoService.getAnsweredMessages(item.user_id).then(response => {
        if (response.data !== null) {
          this.modalUsers = response.data.data.answered_messages || []
        }

        this.modalUsersLoading = false
      }).catch(() => {
        this.modalUsersLoading = false
      })

      this.$refs.modalUsersDetail.show()
    },

    showContactedUsers(item) {
      this.modalType = 'contacted'
      this.modalUsers = []
      this.modalUsersLoading = true

      ExpertoService.getContactedMessages(item.user_id).then(response => {
        if (response.data !== null) {
          this.modalUsers = response.data.data.contacted_messages || []
        }

        this.modalUsersLoading = false
      }).catch(() => {
        this.modalUsersLoading = false
      })

      this.$refs.modalUsersDetail.show()
    },

    closeModal() {
      this.$refs.modalUsersDetail.hide()
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .header-card{
    margin-bottom: 20px;
  }

  .form-buttons button{
    margin-right: 10px;
  }
</style>
